import React from 'react'
import { makeStyles } from '@material-ui/core'

const jss = (theme) => {
    const { colors } = theme['foundations-library']

    return {
        asterisk: {
            color: colors.destructive[500]
        }
    }
}

const useStyles = makeStyles(jss)

/**
 *
 */
const RedAsterisk = (): JSX.Element => {
    const styles = useStyles()
    return <span className={styles.asterisk} data-testid='red-asterisk'>*</span>
}

export default RedAsterisk
